import Axios from "../../api/Axios";
const BASE_URL = "helpdesk/IssueLogger/";

export const EndpointIssueLogger = {
    GetMailId: "GetMailId",
    SaveUserMailDetails: "SaveUserMailDetails"
};

export const createAPIEndpointIssueLogger = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };

};
